import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gradient-to-r from-[#0E3386] to-[#00BFFF] pt-12 pb-6">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 pb-8">
          {/* Company Info */}
          <div className="space-y-4">
            <div className="flex items-center">
              <img
                src={require('../../assets/image/logo.png') || '/placeholder.svg'}
                className="h-14 w-auto"
                alt="Welcome Habibi Trading Logo"
              />
              <div className="ml-3 border-l-2 border-blue-400 pl-3">
                <h3 className="text-white font-bold text-lg">Welcome Habibi Trading</h3>
                <p className="text-blue-200 text-sm">Your trusted partner</p>
              </div>
            </div>

            <p className="text-blue-100 text-sm leading-relaxed">
              Secure your financial future with our comprehensive planning services, expert
              investment strategies, and insightful market research. We've been helping clients
              achieve their goals since 2011.
            </p>

            <div className="pt-2">
              <h4 className="text-white text-sm font-semibold mb-2">Connect With Us</h4>
              <div className="flex gap-3">
                <a
                  href="https://wa.me/923124862727"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-white p-2 rounded-full hover:bg-blue-100 transition-colors"
                  aria-label="WhatsApp"
                >
                  <img
                    src={require('../../assets/image/WhatsApp_icon.png') || '/placeholder.svg'}
                    className="w-6 h-6"
                    alt="WhatsApp"
                  />
                </a>
                <a
                  href="tel:+923124862727"
                  className="bg-white p-2 rounded-full hover:bg-blue-100 transition-colors"
                  aria-label="Call Us"
                >
                  <img
                    src={require('../../assets/image/call.png') || '/placeholder.svg'}
                    className="w-6 h-6"
                    alt="Call"
                  />
                </a>
                <a
                  href="mailto:info@welcomehabibitrading.com"
                  target="_blank"
                  rel="noreferrer"
                  className="bg-white p-2 rounded-full hover:bg-blue-100 transition-colors"
                  aria-label="Email Us"
                >
                  <img
                    src={require('../../assets/image/email.webp') || '/placeholder.svg'}
                    className="w-6 h-6"
                    alt="Email"
                  />
                </a>
                <a
                  href="https://www.facebook.com/profile.php?id=61564993693678"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-white p-2 rounded-full hover:bg-blue-100 transition-colors"
                  aria-label="Facebook"
                >
                  <img
                    src={require('../../assets/image/facebook.webp') || '/placeholder.svg'}
                    className="w-6 h-6"
                    alt="Facebook"
                  />
                </a>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div className="md:ml-auto  ">
            <h3 className="text-white hidden font-bold text-lg mb-4 border-b border-blue-700 pb-2">
              Quick Links
            </h3>
            <ul className="space-y-2 hidden">
              <li>
                <Link
                  to="/"
                  className="text-blue-100 hover:text-white transition-colors flex items-center"
                >
                  <svg
                    className="w-4 h-4 mr-2"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                      clipRule="evenodd"
                    ></path>
                  </svg>
                  Home
                </Link>
              </li>
              <li>
                <Link
                  to="/alerts"
                  className="text-blue-100 hover:text-white transition-colors flex items-center"
                >
                  <svg
                    className="w-4 h-4 mr-2"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                      clipRule="evenodd"
                    ></path>
                  </svg>
                  WHT Alerts
                </Link>
              </li>
              <li>
                <Link
                  to="/gallery"
                  className="text-blue-100 hover:text-white transition-colors flex items-center"
                >
                  <svg
                    className="w-4 h-4 mr-2"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                      clipRule="evenodd"
                    ></path>
                  </svg>
                  WHT Gallery
                </Link>
              </li>
              <li>
                <Link
                  to="/contact"
                  className="text-blue-100 hover:text-white transition-colors flex items-center"
                >
                  <svg
                    className="w-4 h-4 mr-2"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                      clipRule="evenodd"
                    ></path>
                  </svg>
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-white font-bold text-lg mb-4 border-b border-blue-700 pb-2">
              Contact Information
            </h3>
            <ul className="space-y-3">
              <li className="flex items-start">
                <svg
                  className="w-5 h-5 text-blue-300 mr-3 mt-0.5"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                  ></path>
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                  ></path>
                </svg>
                <span className="text-blue-100 text-sm">
                  Hassan Trade Center , City Stop near Shohada Masjid , Sargodha
                </span>
              </li>
              <li className="flex items-start">
                <svg
                  className="w-5 h-5 text-blue-300 mr-3 mt-0.5"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                  ></path>
                </svg>
                <span className="text-blue-100 text-sm">
                  <a href="tel:+923124862727" className="hover:text-white">
                    +92 312 486 2727
                  </a>
                </span>
              </li>
              <li className="flex items-start">
                <svg
                  className="w-5 h-5 text-blue-300 mr-3 mt-0.5"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                  ></path>
                </svg>
                <span className="text-blue-100 text-sm">
                  <a href="tel:+923124862727" className="hover:text-white">
                    +44 7575 837177
                  </a>
                </span>
              </li>
              <li className="flex items-start">
                <svg
                  className="w-5 h-5 text-blue-300 mr-3 mt-0.5"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                  ></path>
                </svg>
                <span className="text-blue-100 text-sm">
                  <a href="mailto:welcomehabibitrading@gmail.com" className="hover:text-white">
                    info@welcomehabibitrading.com
                  </a>
                </span>
              </li>
              <li className="flex items-start">
                <svg
                  className="w-5 h-5 text-blue-300 mr-3 mt-0.5"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                  ></path>
                </svg>
                <span className="text-blue-100 text-sm">Saturday - Thursday: 10:00 - 18:00 </span>
              </li>
              <li className="flex items-start">
                <svg
                  className="w-5 h-5 text-blue-300 mr-3 mt-0.5"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                  ></path>
                </svg>
                <span className="text-blue-100 text-sm">Friday: Holiday </span>
              </li>
            </ul>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-blue-700 my-6"></div>

        {/* Copyright */}
        <div className="flex flex-col md:flex-row justify-between items-center text-center md:text-left">
          <p className="text-blue-200 text-sm">
            © {currentYear} Welcome Habibi Trading. All rights reserved.
          </p>
          <p className="text-blue-300 text-xs mt-2 md:mt-0">
            Designed with <span className="text-red-400">♥</span> by Professional Developer Hammad
            Saeed{' '}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
